import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import useAxios from "@hooks/use-axios";
import { EMAIL_REGEX } from "@helpers/regex";
import { CLIENT_TYPES } from "./misc/constant";

const emailSchema = yup.object({
  email: yup
    .string()
    .required("Email is required")
    .matches(EMAIL_REGEX.pattern, EMAIL_REGEX.msg)
});

/**
 * Passwordless login in three steps: the visitor first picks the client type
 * they're signing in as (brand / publisher / ops), then enters their email,
 * and we call `login/initiate` to have a magic link emailed to them before
 * showing a "check your inbox" confirmation. The link itself lands on
 * /login/callback, which completes the login (see use-login-callback.js).
 */
const useLogin = () => {
  const { axiosInstance, loading } = useAxios({
    base              : "base",
    alertTypeOnSuccess: "toast"
  });
  const [step, setStep] = useState("clientType");
  const [clientType, setClientType] = useState(null);

  const methods = useForm({
    resolver     : yupResolver(emailSchema),
    defaultValues: {
      email: ""
    }
  });

  const selectClientType = (type) => {
    setClientType(CLIENT_TYPES[type] || null);
    setStep("email");
  };

  const onSubmit = methods.handleSubmit(async (data) => {
    const email = data.email.toLowerCase();
    await axiosInstance.post("auth/v1/login/initiate", {
      email,
      login_type: clientType?.loginType
    });
    setStep("sent");
  });

  // "sent" walks back to the email field; the email field walks back to the
  // client-type picker (and forgets the pick, so it can be changed).
  const goBack = () => {
    if (step === "sent") {
      setStep("email");
      return;
    }
    setClientType(null);
    setStep("clientType");
  };

  return {
    onSubmit,
    loading,
    methods,
    step,
    clientType,
    selectClientType,
    goBack
  };
};

export default useLogin;
